<div class="row justify-content-center">
    <div class="bg-white bg-auto">
  
      <!-- <div>
          <img width="250px;" src="data:image/png;base64,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">
      
      </div> -->
      <div class="text-center">
        <h4>Candidate Profile</h4>
        <br/>
      </div>
      <form role="form" >
  
        <table  class="table borderless table-condensed" style="padding-right: 100px;"> 
          <tr>
            <td class="font-weight-bold">Name :</td>
            <td>{{userdata.userName}}</td>
          </tr>
          <tr>
            <td class="font-weight-bold">Email :</td>
            <td>{{userdata.email}}</td>
          </tr>
          <tr>
            <td class="font-weight-bold">Mobile :</td>
            <td>{{userdata.mobileNo}}</td>
          </tr>
          <tr>
            <td class="font-weight-bold">Experience :</td>
            <td>{{userdata.experience}}</td>
          </tr>
        </table>
        <!-- <div >
          <label >Name :</label>
          <label>{{userdata.userName}}</label>
  
        </div>
        <div >
          <label >Email :</label>
          <label>{{userdata.email}}</label>
  
        </div>
        <div >
          <label >Mobile :</label>
          <label>{{userdata.mobileNo}}</label>
  
        </div>
        <div >
          <label >Experience :</label>
          <label>{{userdata.experience}}</label>
  
        </div> -->
  
        
      </form>
      <br>
      
      <div>
        <div class="card">
          <div class="card-body">
            <label class="text-success">PLEASE SPEND SUFFICIENT TIME TO READ ALL THESE BELOW MENTIONED DETAILS, TO AVOID ANY KIND OF LOSS, CONFUSION OR MISUNDERSTANDINGS...</label>
            <ol>
              <li> Once you start the exam, do not refresh your browser, use browser buttons, or navigate
                away from the exam screen until the test is submitted. If you navigate away
                from the test page, test is void.</li>
              <li>Exam is for single use only. It will be deactivated automatically after first use.</li>
              <li>Scheduled / Auto-Scheduled Online exam can not be changed, postponed or extended in any condition.</li>
              
              <li> Use faster, reliable and continued internet connection. </li>
              <li> Keep sufficient power / electricity backup. We are not responsible for any electricity power failure.</li>
              <li>If you take the screenshot the exam will be ended automatically.</li>
            <li>In case of any issue you face during the test, please contact <a href="mailto:support@ariqt.com">@Support</a> </li>
            </ol>    
            <p class="alert alert-info p-sm m-t-lg text-danger font-weight-bold">
              Note: If you read all the instructions very careful, then you will not face any issue during your exam. Good Luck. 
            </p>
          </div>
        </div>
        <br>
        <div class="text-center">
          <button type="submit" class="btn btn-info m-t waves-effect" (click)="getquiz()">Start Test</button>
        </div>
      </div>
    </div>
  </div>